import { Control, Controller, FieldValues } from "react-hook-form";
import { checkIsPhone, validateEmail, validatePrefixZeroPhone } from "@/utils/validate";
import { useEffect, useRef, useState } from "react";
import PhoneCode from "./PhoneCode";
import { useTranslation } from "next-i18next";
import Input from "@/components/Input";

interface Props {
	name: string;
	control: Control<FieldValues>;
	error: boolean;
	helperText: string;
	defaultValue?: string;
	initialPhoneCode?: string;
	classNames?: object;
}

export default function PhoneAndEmailController(props: Props) {
	const { t } = useTranslation("login");
	const inpRef = useRef<HTMLElement>(null);
	const [phoneCode, setPhoneCode] = useState("");
	const [inputVal, setInputVal] = useState("");

	useEffect(() => {
		if (!props.defaultValue) return;
		if (checkIsPhone(props.defaultValue)) {
			setInputVal(props.defaultValue.substring(4, props.defaultValue.length));
			setPhoneCode(props.defaultValue.slice(0, 4));
		} else {
			setInputVal(props.defaultValue);
		}
	}, [props.defaultValue]);

	return (
		<>
			<Controller
				name={props.name}
				control={props.control}
				rules={{
					required: t("validatePhoneAndEmailMsg"),
					validate: {
						checkPhoneNumber: (v) => {
							if (checkIsPhone(v)) return validatePrefixZeroPhone(v) || t("validatePhoneMsg");
							return validateEmail(v) || t("validateEmailMsg");
						},
					},
				}}
				render={({ field }) => (
					<Input
						{...field}
						value={inputVal}
						onChange={(_val) => {
							if (checkIsPhone(_val)) {
								field.onChange(phoneCode + _val);
							} else {
								field.onChange(_val);
							}
							setInputVal(_val);
						}}
						ref={inpRef as any}
						placeholder={t("phone-or-email-number-placeholder")}
						aria-label={t("phone-or-email-number-placeholder")}
						id="phone_email"
						leading={
							<PhoneCode
								value={phoneCode}
								visible={checkIsPhone(inputVal)}
								initialValue={props.initialPhoneCode}
								onChange={(val) => {
									setPhoneCode(val);
									field.onChange(val + field.value.substring(4, field.value.length));
								}}
							/>
						}
					/>
				)}
			/>
		</>
	);
}
